// eslint-disable-next-line @alltrails/custom/use-client
'use client'; // Needed for Cookies.get

import Cookies from 'js-cookie';
import Script from 'next/script';
import { marketingConsentEnabled } from '@alltrails/core/utils/marketingTracking/osanoConsent';

// https://businesshelp.snapchat.com/s/article/pixel-generate-code?language=en_US
export default function SnapchatPixel({ emailSha256 }: { emailSha256?: string | null }) {
  if (!process.env.NEXT_PUBLIC_SNAPCHAT_PIXEL_ID) {
    return null;
  }

  let trackingArgs = {};
  if (marketingConsentEnabled(Cookies.get('at_osano')) && emailSha256) {
    trackingArgs = { user_hashed_email: emailSha256 };
  }
  const stringifiedTrackingArgs = JSON.stringify(trackingArgs);

  return (
    <Script id="snapchat-pixel" strategy="afterInteractive">
      {`
        (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
        {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
        a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
        r.src=n;var u=t.getElementsByTagName(s)[0];
        u.parentNode.insertBefore(r,u);})(window,document,
        'https://sc-static.net/scevent.min.js');

        snaptr('init', '${process.env.NEXT_PUBLIC_SNAPCHAT_PIXEL_ID}', ${stringifiedTrackingArgs});
        snaptr('track', 'PAGE_VIEW', ${stringifiedTrackingArgs});
      `}
    </Script>
  );
}
